
import React from 'react'
import MvStocksPage from './STOCKS/MvStocksPage'

const MvStocks = () => {
  return (
    <MvStocksPage />
  )
}

export default MvStocks
